export const songList = [
  {
    title: "Element",
    artist: "Kendrick Lamar",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618702079/Kendrick/ELEMENT_tp4lep",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618701813/Kendrick/cover_c2qcla",
    color: "#191917"
  },
  {
    title: "Shea Butter Baby",
    artist: "Ari Lennox ft. J.cole",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618702349/J.cole/Shea_Butter_Baby_mvex0l",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618702286/J.cole/Cover_a78jwc",
    color: "#bd9660"
  },
  {
    title: "Wishing Well",
    artist: "Juice Wrld",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618702055/Juice%20Wrld/Wishing_Well_qh2mjn",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618701822/Juice%20Wrld/Cover_yxufju",
    color: "#fd6a8e"
  },
  {
    title: "Topanga",
    artist: "Trippie Redd",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618702251/Trippie%20redd/Topanga_fmognq",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618702064/Trippie%20redd/cover_pagarg",
    color: "#f47f68"
  },
  {
    title: "NO BYSTANDERS",
    artist: "Travis Scott",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618702220/Travis%20Scott/NO_BYSTANDERS_se391g",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618701902/Travis%20Scott/cover_ieakc9",
    color: "#f7c64f"
  },
  {
    title: "Moonlight",
    artist: "XXXtentacion",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618702341/XXXtentacion/Moonlight_t9ubbt",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618702088/XXXtentacion/Cover_xa9nvp",
    color: "#787878"
  },
  {
    title: "Gunna",
    artist: "Gunna ft. Young thug & Wheezy",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618702366/Gunna/3_Headed_Snake_uz5erx",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618702280/Gunna/Cover_bbeepx",
    color: "#439eb3"
  },
  {
    title: " Praise the Lord (Da Shine)",
    artist: "A$AP Rocky ft. Skepta",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618702341/A%24AP/Praise_the_Lord_Da_Shine_i55j3v",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618702142/A%24AP/Cover_dbolhv",
    color: "#9e9617"
  },
  {
    title: "Facts",
    artist: "Kanye West",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618701896/Kanye%20West/Facts_Charlie_Heat_Version_cbo1ct",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618702142/A%24AP/Cover_dbolhv",
    color: "#e28a5c"
  },
  {
    title: "Onyeka",
    artist: "Burna boy",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618702365/Burna%20boy/Onyeka_bozc1s",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618702237/Burna%20boy/cover_fbtvbw",
    color: "#e7bc6a"
  },
  {
    title: "No More Parties",
    artist: "Coi Leray",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618702324/Coi%20Leray/No_More_Parties_ilb9po",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618702242/Coi%20Leray/cover_ldx0ww",
    color: "#f64555"
  },
  {
    title: "10 Freaky Girls",
    artist: "Metro Boomin",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618701938/Metro%20Boomin/10_Freaky_Girls_yhbfkb",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618701818/Metro%20Boomin/Cover_fetatg",
    color: "#f1b746"
  },
  {
    title: "Y.M.C.A.",
    artist: "Village People",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618702381/Village%20People/Y.M.C.A._uz9w4e",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618702070/Village%20People/cover_hfmu90",
    color: "#5369ce"
  },
  {
    title: "Nuketown",
    artist: "Skimask the Slump God",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618702089/Skimask/Nuketown_ibufch",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618701854/Skimask/Cover_kwscqp",
    color: "#765443"
  },
  {
    title: "Circle of bosses",
    artist: "Young thug ft. Quavo",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618702276/Young%20Thug/Circle_of_bosses_sppgxv",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618702094/Young%20Thug/Cover_itz2cg",
    color: "#9bb229"
  },
  {
    title: "No Permission",
    artist: "Nasty C ft. Runtown",
    url:
      "https://res.cloudinary.com/dexg5uy3d/video/upload/v1618702232/Nasty%20C/No_Permission_aw4cvt",
    cover:
      "https://res.cloudinary.com/dexg5uy3d/image/upload/v1618701821/Nasty%20C/cover_ppgmu3",
    color: "#e1495d"
  }
];
